var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyCtrIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.53 4.99992H9.16667V34.9999H30.8333V9.44909L25.53 4.99992ZM7.5 36.6666V3.33325H26.1367L32.5 8.67075V36.6666H7.5ZM11.6667 8.33325H20V9.99992H11.6667V8.33325ZM20 13.3333H11.6667V14.9999H20V13.3333ZM16.535 27.1665L20 32.3282L23.6184 26.939L27.9634 29.0965L28.7042 27.604L23.0492 24.7957L20 29.3382L16.7942 24.5674L14.1667 27.159L12.2875 25.2782L11.11 26.4565L14.1667 29.5074L16.535 27.1665Z",
    fill: "#6E6E6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyCtrIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Empty_Ctr_icon.0ac9850d3553745896b01d0d186c789c.svg";